<template>
  <div class="chartOne">
    <!-- <h4>{{ chartTitle }}</h4> -->
    <div :id="barmain" class="codMain"></div>
  </div>
</template>

<script>

let myChart;

export default {
  name: "BarChart",
  props: {
    barmain: String,
    ChartData: Object,
  },
  data() {
    return {
      // timer: null,
      myChart: null,
      chartData: {},
      seriesData: [],
      openIndex: null,
      chartTitle: "",
      initOption: {
        animation: true,
        animationDuration: 1500,
        dataZoom: [
          {
            type: "inside",
          },
        ],
        legend: {
          data: "",
          icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
          itemWidth: 9, // 设置宽度
          itemHeight: 9, // 设置高度
          itemGap: 30, // 设置间距,
          textStyle: {
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
            padding: [0, 0, -2, 0], //[上、右、下、左]
          },
        },

        grid: {
          top: "10%",
          left: "3%",
          right: "3%",
          bottom: "10%",
          containLabel: true,
        },
        color: ["#70b6ff", "#8ED4C8", "#A8B4ED", "#EE6666", "#FAC858", "#9C64B6"],
        xAxis: {
          type: "category",
          axisLabel: {
            interval: "auto",
            showMaxLabel: true,
          },
        },
        yAxis: {
          axisLine: {
            show: true,
            lineStyle: { color: "#333" },
          },
          type: "value",
        },
        tooltip: {
          confine: true,
          trigger: "axis",
          axisPointer: {
            type: "line",
            z: 0,
            lineStyle: {
              color: "#2D3443",
            },
          },
          textStyle: {
            align: "left",
          },
        },
        series: [
          {
            name: "",
            data: "",
            symbol: "none",
            smooth: true,
            lineStyle: { width: 1.6 },
            type: "bar",
            label: {
              show: false,
              position: "right",
            },
            itemStyle: {
              lineStyle: {
                color: '"#1890ff"',
                width: 1.2,
              },
            },
          },
        ],
      },
    };
  },
  beforeUnmount() {
    myChart.clear();
    // clearInterval(this.timer);
  },
  mounted() {
    console.log(this.ChartData);
    this.initChart();

    console.log(this.initChart);
    window.addEventListener("resize", () => {
      myChart.resize();
    });
  },
  computed: {
    // ...mapState(useCommonStore, ["theme", "open"]),
  },
  watch: {
    open() {
      console.log("edfgbhdfg123");
      myChart.resize();
    },
    theme() {
      myChart.clear();
      this.initChart();
    },
    ChartData() {
      // console.log(22222222222222222);

      myChart.clear();
      this.initChart();
    },
  },
  methods: {
    changevalue(a, b) {
      let some = [a, b];
      return some;
    },
    use() {
      // console.log("111");
    },
    initChart() {
      console.log(this.ChartData);
      // this.chartTitle = this.ChartData.board;
      this.initOption.xAxis.data = this.ChartData.xAxis;
      this.initOption.title = {
        left: "5%",
        text: this.chartTitle,
        show: false,
      };
      this.initOption.yAxis = [
        {
          type: "value",
          splitLine: {
            show: false
          }
        },
      ];
      this.initOption.series = [
        {
          data: this.ChartData.legend[0].yAxis,
          type: "bar",
          itemStyle: {
            barBorderRadius: [6, 6, 0, 0], //柱体圆角
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "rgb(56, 184, 173,1)",
                // (43, 107, 170, 0.84)
              },
              {
                offset: 1,
                color: "rgb(0, 128, 128,0) ",
              },
            ]),
          },
        },
      ];

      let newPromise = new Promise((resolve) => {
        resolve();
      });
      newPromise.then(() => {
        console.log(this.theme);
        let that = this;
        myChart = this.$echarts.init(
          document.getElementById(this.barmain),
          this.theme
        ); // 使用dark 、light或无第二参数
        myChart.setOption(this.initOption);
        // console.log(myChart);
        myChart.getZr().on("click", function (param) {
          if (param.offsetY > 60) {
            that.$emit("closedrawer");
            console.log(23232434343);
            console.log(param);
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.chartOne {
  width: 100%;
  // height: 100px;
  margin: 0 auto;
  // margin-right: 100px;

  ::-webkit-scrollbar {
    border-radius: 6px;
    width: 5px !important;
    background-color: #ccc;
  }

  ::-webkit-scrollbar-thumb {
    //滑块部分
    border-radius: 6px;
    background-color: #989898;
    height: 30px;
  }

  ::-webkit-scrollbar {
    display: none;
  }

  .codMain {
    width: 100%;
    height: 220px;
    margin: 0 auto;
  }

  h4 {
    padding-top: 10px;
    padding-left: 36px;
    font-size: 16px;
    color: rgb(76, 76, 76);
  }
}
</style>
